import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Locations() {
  const {
    t
  } = useLanguage();
  const locations = [{
    name: t('loc.polanco'),
    address: t('locations.address.polanco')
  }, {
    name: t('loc.santafe'),
    address: t('locations.address.santafe')
  }, {
    name: t('loc.lomas'),
    address: t('locations.address.lomas')
  }];
  return <section id="ubicaciones" className="py-32 bg-white border-y border-gray-200" data-id="element-223">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-225">
          <h2 className="inline-flex items-center px-5 py-2.5 rounded-full border border-gray-300 text-gray-500 font-medium tracking-[0.2em] uppercase text-xs" data-id="element-226">
            {t('locations.title')}
          </h2>
        </motion.div>

        <div className="flex flex-col lg:flex-row divide-y lg:divide-y-0 lg:divide-x divide-gray-200" data-id="element-227">
          {locations.map((loc, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex-1 py-12 lg:py-0 lg:px-12 first:pt-0 lg:first:pl-0 last:pb-0 lg:last:pr-0 group cursor-pointer relative overflow-hidden" data-id="element-228">
              <div className="flex flex-col h-full justify-center" data-id="element-229">
                <div className="flex items-center gap-4 mb-4 opacity-0 -translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 text-bodyon-teal" data-id="element-230">
                  <MapPin className="w-6 h-6" data-id="element-231" />
                  <span className="font-medium tracking-wider uppercase text-sm" data-id="element-232">
                    {t('locations.viewMap')}
                  </span>
                </div>

                <h3 className="font-heading font-black text-5xl md:text-6xl text-gray-300 group-hover:text-bodyon-teal-dark transition-colors duration-500 tracking-tighter" data-id="element-233">
                  {loc.name}
                </h3>

                <div className="h-0 opacity-0 group-hover:h-auto group-hover:opacity-100 group-hover:mt-6 transition-all duration-500 overflow-hidden" data-id="element-234">
                  <p className="text-xl text-gray-500 font-light" data-id="element-235">
                    {loc.address}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}